import { CrudFilters } from '@pankod/refine-core'

// refine-supabase v3 forwards operators inside OR directly to PostgREST,
// unlike top-level operators. Include NULL descriptions to retain manual coupons.
export const automaticCouponFilters = (showAutomatic: boolean): CrudFilters => {
  if (showAutomatic) return []
  return ['CRM birthday %', 'CRM automatic action %'].map(pattern => ({
    operator: 'or',
    value: [
      { field: 'description', operator: 'is', value: 'null' },
      { field: 'description', operator: 'not.like', value: pattern }
    ]
  })) as unknown as CrudFilters
}
